import { useEffect, useState } from 'react';
import Hero from './components/Hero';
import Challenges from './components/Challenges';
import Solutions from './components/Solutions';
import WhyChoose from './components/WhyChoose';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}>
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center">
            <a href="https://www.avertnetworkservices.com" className="cursor-pointer">
              <img 
                src="https://static.readdy.ai/image/9041450fc173856249e31fa6f138bbf1/d4dcc7683c3c12c9546c661fe2f1d1c5.png" 
                alt="Logo" 
                className="h-12 w-auto"
              />
            </a>
          </div>
          
          <div className="hidden lg:flex items-center space-x-6">
            <button 
              onClick={() => scrollToSection('challenges')}
              className={`text-sm transition-colors cursor-pointer whitespace-nowrap ${
                scrolled ? 'text-gray-600 hover:text-[#e10708]' : 'text-white/80 hover:text-white'
              }`}
            >
              Problems We Solve
            </button>
            <button 
              onClick={() => scrollToSection('solutions')}
              className={`text-sm transition-colors cursor-pointer whitespace-nowrap ${
                scrolled ? 'text-gray-600 hover:text-[#e10708]' : 'text-white/80 hover:text-white'
              }`}
            >
              Our Services
            </button>
            <button 
              onClick={() => scrollToSection('why-choose')}
              className={`text-sm transition-colors cursor-pointer whitespace-nowrap ${
                scrolled ? 'text-gray-600 hover:text-[#e10708]' : 'text-white/80 hover:text-white'
              }`}
            >
              Why Choose Us
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className={`text-sm transition-colors cursor-pointer whitespace-nowrap ${
                scrolled ? 'text-gray-600 hover:text-[#e10708]' : 'text-white/80 hover:text-white'
              }`}
            >
              Contact
            </button>
          </div>

          <div className="hidden md:flex items-center space-x-4">
            <a 
              href="tel:+18552837848"
              className={`flex items-center text-sm transition-colors cursor-pointer whitespace-nowrap ${
                scrolled ? 'text-gray-600 hover:text-[#e10708]' : 'text-white/80 hover:text-white'
              }`}
            >
              <i className="ri-phone-fill mr-2 w-4 h-4 flex items-center justify-center"></i>
              (855) 283-7848
            </a>
            <a 
              href="mailto:legal@avertnetworkservices.com"
              className={`flex items-center text-sm transition-colors cursor-pointer whitespace-nowrap ${
                scrolled ? 'text-gray-600 hover:text-[#e10708]' : 'text-white/80 hover:text-white'
              }`}
            >
              <i className="ri-mail-fill mr-2 w-4 h-4 flex items-center justify-center"></i>
              legal@avertnetworkservices.com
            </a>
            <button 
              onClick={() => scrollToSection('contact')}
              className="bg-[#e10708] text-white px-6 py-3 rounded-full text-sm font-medium hover:bg-[#c10607] hover:shadow-lg hover:shadow-[#e10708]/30 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Schedule Consultation
            </button>
          </div>
        </div>
      </nav>

      <Hero />
      <Challenges />
      <Solutions />
      <WhyChoose />
      <Contact />
      <Footer scrollToSection={scrollToSection} />
    </div>
  );
}